var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "liga") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-1617.000000, -6528.000000)",
    stroke: "",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "mn-copy-3",
    transform: "translate(1330.000000, 6446.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(252.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "liga",
    transform: "translate(36.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7996995,13.9360001 C15.6634952,14.2240001 15.4872321,14.4960004 15.2548836,14.7520004 C14.8622947,15.1840004 14.4296447,15.4960007 13.9409115,15.6960007 C13.4601904,15.8960007 12.9394102,16 12.3785689,16 C11.561343,16 10.6880321,15.8080004 9.76664997,15.4160004 C8.84526789,15.0240004 7.92388609,14.4960007 7.01051601,13.8320007 C6.08913393,13.1600008 5.21582372,12.4159998 4.38257384,11.5919998 C3.55733598,10.7599998 2.81221827,9.8880002 2.14722077,8.97600021 C1.49023527,8.06400023 0.961442211,7.15200033 0.576865341,6.24800034 C0.192288471,5.33600035 0,4.46399994 0,3.63199997 C0,3.08799996 0.0961441399,2.56800013 0.288432575,2.08800011 C0.48072101,1.6000001 0.785177809,1.15200005 1.20981476,0.752000046 C1.72258392,0.24800005 2.28342533,0 2.87631469,0 C3.10065121,0 3.32498767,0.0480000556 3.52528813,0.144000053 C3.7336006,0.240000051 3.91787708,0.384000015 4.06209342,0.592000008 L5.9208818,3.20800018 C6.06509814,3.40800018 6.16925406,3.59200003 6.24136223,3.76800003 C6.31347039,3.93600003 6.35353076,4.10400014 6.35353076,4.25600014 C6.35353076,4.44800013 6.2974466,4.63999978 6.18527834,4.82399979 C6.08112211,5.00799979 5.92889342,5.19999982 5.73660498,5.39199982 L5.12769141,6.02399979 C5.03955921,6.11199979 4.99949924,6.21600025 4.99949924,6.34400024 C4.99949924,6.40800024 5.00751181,6.46399988 5.02353584,6.52799988 C5.0475719,6.59199988 5.07160789,6.63999973 5.08763193,6.68799973 C5.23184826,6.95199974 5.48022031,7.29600029 5.83274911,7.71200027 C6.19328992,8.12800026 6.57786667,8.55200024 6.99449161,8.97600021 C7.42714062,9.40000019 7.8437657,9.79199967 8.26840264,10.1519997 C8.68502758,10.5039997 9.02954435,10.7439997 9.30195297,10.8879997 C9.34201307,10.9039997 9.39008542,10.9279997 9.44616955,10.9519997 C9.51026569,10.9759997 9.57436184,10.9839996 9.64647001,10.9839996 C9.78267432,10.9839996 9.88683043,10.9360003 9.97496263,10.8480003 L10.5838762,10.2480003 C10.7841767,10.0480003 10.9764653,9.896 11.1607417,9.8 C11.3450182,9.688 11.5292938,9.63199997 11.7295943,9.63199997 C11.8818227,9.63199997 12.0420635,9.66400006 12.2183279,9.73600006 C12.3945923,9.80800006 12.5788693,9.91200033 12.7791698,10.0480003 L15.4311474,11.9279999 C15.6394599,12.0719999 15.7836756,12.2399994 15.8718078,12.4399994 C15.951928,12.6399994 16,12.8399999 16,13.0639999 C16,13.352 15.9359039,13.648 15.7996995,13.9360001 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.421594,5.44000015 L14.421594,1.6 L14.421594,5.44000015 Z M14.421594,1.6 L10.575825,1.6",
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiga);
export default __webpack_public_path__ + "static/media/liga.a47720d1b5387cd3bb47d062843f1ca6.svg";
export { ForwardRef as ReactComponent };